import { type IBaseWidget } from '@framework/engine/schema/widgets/IBaseWidget.ts';
import { type WidgetType } from '@framework/engine/schema/widgets/Widget.ts';

export const WidgetSectionType = 'section' as WidgetType.Section;

export interface ISectionWidget extends IBaseWidget {
  name?: string | null;
  placeholder?: string | null;
}
